import { useRef, useState, useEffect, Suspense, lazy } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const ScissorsScene = lazy(() => import("./ScissorsScene"));

const ScissorsReveal = () => {
  const ref = useRef(null);
  const [touch, setTouch] = useState(false);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const opacity = useTransform(scrollYProgress, [0, 0.93, 1], [1, 1, 0]);

  useEffect(() => {
    setTouch(window.matchMedia("(pointer: coarse)").matches);
  }, []);

  return (
    <section ref={ref} data-testid="scissors-section" className={`relative bg-[#0B1F3A] ${touch ? "h-[180vh]" : "h-[260vh]"}`}>
      <div className="sticky top-0 h-screen overflow-hidden noise-overlay">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_50%,rgba(255,255,255,0.14),transparent_60%)]" />
        <motion.div style={{ opacity }} className="absolute inset-0" data-testid="hero-scissors-canvas">
          <Suspense fallback={null}>
            <ScissorsScene progress={scrollYProgress} light={touch} />
          </Suspense>
        </motion.div>
      </div>
    </section>
  );
};

export default ScissorsReveal;
